import translator from 'src/translate'
import { withStyles } from '@material-ui/core/styles'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styles from '../styles'

import { CircularProgress, Typography } from '@material-ui/core'

import { useCourseSettings, useCourse } from 'src/hooks/useCourseSettings'
import CountrySelect from 'src/components/language-selection'
import { languages } from 'src/model/languages'
import { useDispatch } from 'react-redux'
import {
  settingsDrawerOpenSuccess,
  courseSettingPatchById,
} from 'src/reducers/course/action'
import { CoreButton } from 'src/components/core'

const SETTING_KEY = 'language'

// Fall back to English when the saved code isn't in the list (a language
// added since this bundle was built).
const findLanguage = code =>
  languages.find(x => x.countryCode === code) ||
  languages.find(x => x.countryCode === 'en')

/**
 * The course language. Built-in texts (buttons, messages) are edited per
 * language for the whole workspace in Workspace > Language.
 */
const LanguageSettings = props => {
  // `onSaved` replaces the drawer close when the tab is rendered inline.
  const { classes, onSaved } = props
  const course = useCourse()
  const dispatch = useDispatch()
  const history = useHistory()
  const { value } = useCourseSettings(SETTING_KEY)

  const savedCode = value?.selected || 'en'
  const [languageSelection, setLanguageSelection] = useState(
    findLanguage(savedCode),
  )
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLanguageSelection(findLanguage(savedCode))
  }, [savedCode])

  const close = () => {
    if (onSaved) onSaved()
    else dispatch(settingsDrawerOpenSuccess())
  }

  const save = () => {
    if (!course || !languageSelection) return
    const settingId =
      course.settingDtos?.find(x => x.key === SETTING_KEY)?.id || 0
    setLoading(true)
    dispatch(
      courseSettingPatchById(
        course.id,
        settingId,
        { value: JSON.stringify({ selected: languageSelection.countryCode }) },
        () => {
          setLoading(false)
          close()
        },
      ),
    )
  }

  const editTexts = () => {
    close()
    history.push(`/workspace/language?lang=${languageSelection.countryCode}`)
  }

  return (
    <div className={classes.content}>
      <div className={classes.root__bg}>
        <CountrySelect
          languageSelection={languageSelection}
          setLanguageSelection={selection =>
            selection && setLanguageSelection(selection)
          }
        />
        <Typography fontSize="13px" color="#637381" mt={1}>
          Buttons and messages in this course use this language.{' '}
          <a
            href={`/workspace/language?lang=${languageSelection.countryCode}`}
            onClick={event => {
              event.preventDefault()
              editTexts()
            }}
          >
            Edit interface text
          </a>
        </Typography>
      </div>
      <div className={classes.bottomButton}>
        {loading ? (
          <CircularProgress />
        ) : (
          <CoreButton
            fullWidth={true}
            color="success"
            size="small"
            variant="contained"
            onClick={save}
          >
            {translator._('assignment.courseSettings.save')}
          </CoreButton>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(LanguageSettings)
